import React from "react";

const UpdateProService = () => {
  return <div>update pro service</div>;
};

export default UpdateProService;
